import Quill from "quill"
import Delta from "quill-delta"

function countChars(delta) {
  return delta
    .filter((op) => typeof op.insert === "string")
    .map((op) => op.insert.length)
    .reduce((acc, cur) => acc + cur, 0)
}

class CharsCounter {
  constructor(quill, options) {
    quill.on(Quill.events.TEXT_CHANGE, (delta, oldDelta, source) => {
      const newDelta = oldDelta.compose(delta)

      const { el, maxChars } = options

      const currentCount = countChars(newDelta)

      const isExceeding = currentCount > maxChars

      if (isExceeding) {
        el.querySelector(`[data-item="extra"]`).innerHTML =
          currentCount - maxChars
      }

      if (isExceeding) {
        el.classList.remove("hidden")
      } else {
        el.classList.add("hidden")
      }
    })
  }
}

Quill.register("modules/charsCounter", CharsCounter)
